import { BsCashCoin } from 'react-icons/bs';

import BaseEditWidget from '../BaseEditWidget';
import '../../EditWidget/EditWidget.scss';

const EditFinancial = (props: any) => {
	return (
		<BaseEditWidget
			{...props}
			defaultIcon={{
				name: 'BsCashCoin',
				label: 'cash-coin',
				component: BsCashCoin,
			}}
			defaultTheme="green"
			widgetType="financial"
		/>
	);
};

export default EditFinancial;
